import store from "~/js/store/store";
import { gsap, Sine } from "gsap";
import _each from "lodash/each";
export default class Selector {
  constructor(_contents, isSticky) {
    const contents = _contents || document.querySelector(".c-selector");
    this.isSticky = isSticky;
    if (!contents) {
      return;
    }
    this.contents = contents;

    this.brandTabs = contents.querySelectorAll(".f-brandTab");
    this.itemTabs = contents.querySelectorAll(".f-itemTab");
    this.overlayEl = contents.querySelector('.c-selector__overlay')

    this.brandList = contents.querySelector(".f-brandList");
    this.itemList = contents.querySelector(".f-itemList");

    this.womensTab = contents.querySelector(".f-womensTab");
    this.mensTab = contents.querySelector(".f-mensTab");
    this.bagTab = contents.querySelector(".f-bagTab");
    this.accessoriesTab = contents.querySelector(".f-accessoriesTab");

    this.womensList = contents.querySelector(".f-womensList");
    this.mensList = contents.querySelector(".f-mensList");
    this.bagList = contents.querySelector(".f-bagList");
    this.accessoriesList = contents.querySelector(".f-accessoriesList");

    this.state = "Close"; //Brand, Item, Close
    this.subState = "Close"; //Womens, Mens, Bag, Accessories, Close

    this.setup();
    this.setupSubscribe();
    this.clickOverlay();

    //モーダル表示時にフォーカスを操作
    this.brandListElements = this.brandList.querySelectorAll("a,button,input");
    this.itemListElements = this.itemList.querySelectorAll("a,button,input");
    document.addEventListener('keydown', function(event)
    {
      var tabKey = (9 === event.keyCode);
      if(tabKey)
      {
        if(this.state=="Brand")
        {
          var activeEl = document.activeElement;
          var lastEl = this.brandListElements[this.brandListElements.length - 1];
          if(lastEl === activeEl)
          {
            event.preventDefault();
            console.log(this.brandTabs[0])
            this.brandTabs[0].focus();
            this.stateChange("Close");
          }
        }
        else if(this.state=="Item")
        {
          var activeEl = document.activeElement;
          var lastEl = this.itemListElements[this.itemListElements.length - 1];
          if(lastEl === activeEl)
          {
            event.preventDefault();
            this.itemTabs[0].focus();
            this.stateChange("Close");
          }
        }
      }
    }.bind(this));
  }

  setup() {
    for (var i = 0; i < this.brandTabs.length; i++) {
      this.brandTabs[i].addEventListener("click", (event) => {
        if (this.state != "Brand") {
          this.stateChange("Brand");
          this.scrollTo(event.currentTarget);
          this.brandListElements[0].focus();
        } else {
          this.stateChange("Close");
        }
      });
    }
    for (var i = 0; i < this.itemTabs.length; i++) {
      this.itemTabs[i].addEventListener("click", (event) => {
        if (this.state != "Item") {
          this.stateChange("Item");
          this.scrollTo(event.currentTarget);
          this.itemListElements[0].focus();
        } else {
          this.stateChange("Close");
        }
      });
    }
    this.womensTab.addEventListener("click", (event) => {
      if (this.subState != "Womens") {
        this.subStateChange("Womens");
        this.scrollTo(event.currentTarget);
      } else {
        this.subStateChange("Close");
      }
    });
    this.mensTab.addEventListener("click", (event) => {
      if (this.subState != "Mens") {
        this.subStateChange("Mens");
        this.scrollTo(event.currentTarget);
      } else {
        this.subStateChange("Close");
      }
    });
    this.bagTab.addEventListener("click", (event) => {
      if (this.subState != "Bag") {
        this.subStateChange("Bag");
        this.scrollTo(event.currentTarget);
      } else {
        this.subStateChange("Close");
      }
    });
    this.accessoriesTab.addEventListener("click", (event) => {
      if (this.subState != "Accessories") {
        this.subStateChange("Accessories");
        this.scrollTo(event.currentTarget);
      } else {
        this.subStateChange("Close");
      }
    });
  }

  setupSubscribe() {
    this.unsubscribe = store.subscribe((mutation, state) => {
      if (mutation.type === "updateStickyPin") {
        if (!state.app.sticky.isSticky) {
          if (this.isSticky) {
            this.stateChange("Close");
          }
        }
      } else if (mutation.type === "scrollY") {
        if (store.getters["isScrollDown"] && state.app.sticky.isSticky) {
          if (this.isSticky) {
            this.stateChange("Close");
          }
        }
      }
    });
  }

  stateChange(_state) {
    this.state = _state;
    for (var i = 0; i < this.brandTabs.length; i++) {
      this.brandTabs[i].classList.remove("open");
      this.brandTabs[i].setAttribute('aria-expanded', 'false')
    }
    for (var i = 0; i < this.itemTabs.length; i++) {
      this.itemTabs[i].classList.remove("open");
      this.itemTabs[i].setAttribute('aria-expanded', 'false')
    }
    this.brandList.classList.remove("open");
    this.brandList.setAttribute('tabindex', '-1')
    this.brandList.setAttribute('aria-hidden', 'true')
    this.itemList.classList.remove("open");
    this.itemList.setAttribute('tabindex', '-1')
    this.itemList.setAttribute('aria-hidden', 'true')
    switch (this.state) {
      case "Brand":
        for (var i = 0; i < this.brandTabs.length; i++) {
          this.brandTabs[i].classList.add("open");
          this.brandTabs[i].setAttribute('aria-expanded', 'true')
        }
        this.brandList.setAttribute('tabindex', '1')
        this.brandList.setAttribute('aria-hidden', 'false')
        this.brandList.classList.add("open");
        this.contents.classList.add("open");
        break;
      case "Item":
        for (var i = 0; i < this.itemTabs.length; i++) {
          this.itemTabs[i].classList.add("open");
          this.itemTabs[i].setAttribute('aria-expanded', 'true')
        }
        this.itemList.setAttribute('tabindex', '1')
        this.itemList.setAttribute('aria-hidden', 'false')
        this.itemList.classList.add("open");
        this.contents.classList.add("open");
        break;
      case "Close":
        this.contents.classList.remove("open");
        break;
    }
  }

  subStateChange(_subState) {
    this.subState = _subState;
    this.womensTab.classList.remove("open");
    this.mensTab.classList.remove("open");
    this.bagTab.classList.remove("open");
    this.accessoriesTab.classList.remove("open");
    this.womensList.classList.remove("open");
    this.mensList.classList.remove("open");
    this.bagList.classList.remove("open");
    this.accessoriesList.classList.remove("open");
    switch (this.subState) {
      case "Womens":
        this.womensTab.classList.add("open");
        this.womensList.classList.add("open");
        break;
      case "Mens":
        this.mensTab.classList.add("open");
        this.mensList.classList.add("open");
        break;
      case "Bag":
        this.bagTab.classList.add("open");
        this.bagList.classList.add("open");
        break;
      case "Accessories":
        this.accessoriesTab.classList.add("open");
        this.accessoriesList.classList.add("open");
        break;
    }
  }

  scrollTo(_element) {
    if (store.getters["isSP"]()) {
      //SP
      var _rect = _element.getBoundingClientRect();
      var _top = _rect.top + window.pageYOffset;
      gsap.to(document.documentElement, {
        scrollTop: _top,
        duration: 0.6,
        ease: Sine.easeInOut
      });
    }
  }

  clickOverlay () {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.c-selector__overlay')) {
        this.stateChange("Close")
      }
    })
  }
}
